<div>
  <table class="table">
    <tr>
      <th>Total Max Power Output</th>
      <th>Total Max Energy Output</th>
      <th>Nominated Power</th>
      <th>Point of Measurement</th>
      <th>Market Auction</th>
      <th>Notification Lead Time</th>
      <th>Incentive</th>
      <th>Penalty</th>
    </tr>
    <tr>
      <td>{{maxOutput}} kW</td>
      <td>{{maxEnergy}} kWh</td>
      <td>{{program.properties.nominatedKw}} kW</td>
      <td>{{cleanProgramText(program?.properties.pointOfMeasurement, 'pointOfMeasurement')}}</td>
      <td>{{(program.properties.marketAuction) ? 'Yes' : 'No' }}</td>
      <td>{{program.properties.notificationTimeframe}}</td>
      <td>{{program.properties.programIncentive}} $/kW</td>
      <td>{{program.properties.programPenalty}} $/kW</td>
    </tr>
  </table>
</div>
